import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_wlog0i1yg7: FaireBrandEntity = {
  token: "b_wlog0i1yg7",
  type: "brand",
  name: "SØUL CHAI",
  avatarUrl:
    "https://cdn.faire.com/fastly/fdfebe6f2e3bb570c25e44967178ed60a912e198b57e3f66973a7edc2b8fb181.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/9b5e249bb99573a6683dade8d12363b6f0dcf7218c5c624132aa1eec397e9a23.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/fdfebe6f2e3bb570c25e44967178ed60a912e198b57e3f66973a7edc2b8fb181.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/9b5e249bb99573a6683dade8d12363b6f0dcf7218c5c624132aa1eec397e9a23.jpeg",
  location: "Portland, OR, USA",
  minimumOrderDollars: 139,
  rating: 5,
  reviewCount: 20,
  isInsider: true,
  description:
    "SØUL CHAÍ is the stuff mugs dream about when they sleep in your cupboards at night~ No Sweeteners, preservatives or water- just chai! \n\nSally & Esar are former baristi and specialty coffee educators. They struggled to feel represented or proud to serve the sugary & diluted liquid chai concentrates that many cafes carry out of convenience. As Chai is such an important daily ritual for South Asians, Soul was born from their desire to offer an authentic, delicious and far more sustainable offering for these spaces. Soul Chai is minimally packaged in infinitely recycled steel tins ❤️\n\nSØUL is an AAPI, women-owned business offering traditional & caffeine-free Rooibos Masala Chai for wholesale and home. Their blends are undiluted & freshly microground for big aroma and a spice-forward base that supports beautiful latte art! Each batch of Soul Chai is is meticulously quality controlled and left unsweetened for those who prefer soul-warming to sweet. It’s powdered form meets people where they are as a quick, strainer-free and entirely customizable ritual. A teaspoon adds nostalgia and kick to anything you sprinkle it in!  ",
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:03:43.214Z",
    importedBy: "entity-db-cli",
  },
};
